import { useState, useEffect } from "react";
import AdminAuth from "@/components/AdminAuth";
import ElementorAdminDashboard from "@/components/ElementorAdminDashboard";

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const authStatus = localStorage.getItem("adminAuthenticated");
    const loginTime = localStorage.getItem("adminLoginTime");
    
    if (authStatus === "true" && loginTime) {
      // Check if session is still valid (24 hours)
      const now = Date.now();
      const loginTimestamp = parseInt(loginTime);
      const sessionDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      
      if (now - loginTimestamp < sessionDuration) {
        setIsAuthenticated(true);
      } else {
        // Session expired
        localStorage.removeItem("adminAuthenticated");
        localStorage.removeItem("adminLoginTime");
      }
    }
    
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground arabic-text">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {!isAuthenticated ? (
        <AdminAuth onLogin={handleLogin} />
      ) : (
        <ElementorAdminDashboard onLogout={handleLogout} />
      )}
    </>
  );
};

export default Admin;